"use client";
import * as React from "react";
const SvgHelpRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m.8 12.8a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0m1.66-5.4-.72.74c-.4.4-.7.77-.84 1.35a4 4 0 0 0-.1.91H7.2V10a3.2 3.2 0 0 1 .94-2.26l.99-1.01c.37-.35.54-.88.44-1.44a1.6 1.6 0 0 0-1.11-1.23 1.6 1.6 0 0 0-1.98 1.02c-.1.3-.34.52-.66.52h-.24a.7.7 0 0 1-.65-.9A3.2 3.2 0 0 1 7.5 2.44c1.22-.2 2.38.44 3.1 1.44.94 1.3.66 2.7-.15 3.52" }));
export {
  SvgHelpRound as default
};
